import { IEntity } from "./entity"
import { mapDateFromApi } from "src/core/utils"
import { mapPaginationFromApi } from './paginated'

export interface ITransaction extends IEntity {
    id: string;
    created_at: Date;
    created_by?: string;
    tag?: string;
    custom?: any;

    status?: string;
    category_produit?: string;
    type_de_trade?: string;
    numero_du_trade?: string;
    numero_du_contrat?: string;
    code_strategy?: string;
    efs_code?: string;
    distributor_network: string;
    topaze_id?: string;
    typologie_operation?: string;
    type_de_produit?: string;
    date_operation?: Date;
    date_de_valeur_operation?: Date;
    date_expiration?: Date;
    date_de_maturite?: Date;
    nominal?: number;
    nominal_restant?: number;
}

export interface ITransactionChange extends IEntity {
    transaction: ITransaction;
    import_export?: string;
    indicateur_call_put?: string;
    sens_du_trade_1?: string;
    devise_1?: string;
    devise_2?: string;
    prix_exercice_option_1?: number;
    cours_spot?: number;
    cours_terme?: number;
    style_de_barriere?: string;
    niveau_barriere?: number;
    fx_accu_engagment_mise_en_place?: number;
    fx_accu_montant_max_accumulable_par_fixing?: number;
    fx_accu_montant_accumule_non_leve?: number;
    fx_accu_barriere_inferieure?: number;
    fx_accu_barriere_superieure?: number;
    ratios_accumulation?: string;
    barriere_basse?: number;
    barriere_haute?: number;
    valorisation_cc?: number;
    montant_couru?: number;
    date_valorisation?: Date;
    fixings_restants_de_laccumulateur?: any;
    frequence_de_fixing_de_laccumulateur?: any;
    date_du_prochain_fixing?: Date;
    reserve_de_figures?: any;
    consommation_de_figures?: any;
}

export interface ITransactionDette extends IEntity {
    transaction: ITransaction;
    categorie_fo_risque_de_produit?: string;
    date_de_paiement_du_flux_interet_1?: Date;
    sens_du_trade_1?: string;
    devise_1?: string;
    type_de_taux_1?: string;
    taux_1?: number;
    floored_rate_1?: string;
    structured_rate_1?: string;
    date_de_paiement_du_flux_interet_2?: Date;
    sens_du_trade_2?: string;
    devise_2?: string;
    type_de_taux_2?: string;
    taux_2?: number;
    floored_rate_2?:  string;
    structured_rate_2?:  string;
    prix_exercice_option_1?: number;
    style_de_barriere?:  string;
    niveau_barriere?: number;
    strike_option_1?: number;
    strike_option_2?: number;
    valorisation_pdc?: number;
    valorisation_cc?: number;
    montant_couru?: number;
    date_valorisation?: Date;
}

export interface ITransactionPlacement extends IEntity {
    transaction: ITransaction;
    code_isin?: string;
    date_de_paiement_du_flux_interet_1?: Date;
    clean_price?: number;
    sens_du_trade_1?: string;
    devise_1?: string;
    type_de_taux_1?: string;
    taux_1?: number;
    structured_rate_1?: string;
    prix_exercice_option_1?:number;
    style_de_barriere?:string;
    niveau_barriere?: number;
    strike_option_1?: number;
    strike_option_2?: number;
    strike?: number;
    date_de_strike?: Date;
    prochain_fixing?: Date;
    cours?: number;
    valorisation_pdc?: number;
    valorisation_cc?: number;
    montant_couru?: number;
    date_valorisation?: Date;
}


export const mapTransactionFromApi = (apiTransaction: any): any => ({
    ...apiTransaction,
    created_at: mapDateFromApi(apiTransaction.created_at),
    ...apiTransaction.date_de_maturite && { date_de_maturite: mapDateFromApi(apiTransaction.date_de_maturite) },
    ...apiTransaction.date_expiration && { date_expiration: mapDateFromApi(apiTransaction.date_expiration) },
    ...apiTransaction.date_de_valeur_operation && { date_de_valeur_operation: mapDateFromApi(apiTransaction.date_de_valeur_operation) },
    ...apiTransaction.date_de_paiement_du_flux_interet_1 && { date_de_paiement_du_flux_interet_1: mapDateFromApi(apiTransaction.date_de_paiement_du_flux_interet_1) },
    ...apiTransaction.date_de_paiement_du_flux_interet_2 && { date_de_paiement_du_flux_interet_2: mapDateFromApi(apiTransaction.date_de_paiement_du_flux_interet_2) },
    ...apiTransaction.date_valorisation && { date_valorisation: mapDateFromApi(apiTransaction.date_valorisation) },
})
  
export const mapTransactionPaginationFromApi = mapPaginationFromApi<any>(mapTransactionFromApi)


// WEBPACK FOOTER //
// ./src/type/transaction.ts